module.exports = __webpack_public_path__ + "img/Convertible_Front_Side_Right_Transparent.356a0070.svg";